import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=1a806404&scoped=true"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountForm.vue?vue&type=style&index=0&id=1a806404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a806404",
  null
  
)

export default component.exports